<template>
  <li v-show="visible" :class="classes.container" class="fw-tab">
    <div
      :class="[classes.wrapper, { 'fw-tab__wrapper--invalid': invalid && !active }]"
      class="fw-tab__wrapper"
      tabindex="0"
      role="tab"
      :aria-selected="active"
      @click.prevent="select"
      @keypress.enter.space.prevent="select"
    >
      <span class="fw-tab__index">{{ index + 1 }}</span>
      <slot>
        <!-- If label is a component -->
        <span v-if="isLabelComponent" class="fw-tab__label">
          <component :is="tabLabel" :form$="form$"/>
        </span>

        <!-- If label is HTML -->
        <span v-else class="fw-tab__label" v-html="tabLabel"></span>
      </slot>
      <span v-if="invalid && !active" class="fw-tab__badge fw-tab__badge--error" :aria-label="form$?.$vueform?.i18n?.locales?.[form$.$vueform.i18n.locale]?.festiware?.tabs?.errorBadge || 'Error'">!</span>
    </div>
  </li>
</template>

<script>
  export default {
    name: 'FormTab',
    data() {
      return {
        merge: true,
        defaultClasses: {
          container: 'vf-tab',
          wrapper: 'vf-tab-wrapper',
          wrapper_active: 'vf-tab-wrapper-active',
          wrapper_inactive: '',
          wrapper_valid: '',
          wrapper_invalid: 'vf-tab-wrapper-invalid',
          wrapper_sm: 'vf-tab-wrapper-sm',
          wrapper_md: '',
          wrapper_lg: 'vf-tab-wrapper-lg',
          $container: (classes, {}) => ([
            classes.container,
          ]),
          $wrapper: (classes, { active, invalid, Size }) => ([
            classes.wrapper,
            classes[`wrapper_${Size}`],
            active ? classes.wrapper_active : classes.wrapper_inactive,
            invalid ? classes.wrapper_invalid : classes.wrapper_valid,
          ]),
        }
      }
    }
  }
</script>

<!-- Styles in assets/styles/newform/_tabs.scss -->
